import { monitoring, login } from "../../modules";

export default {
  monitoring: monitoring.store,
  dialog: monitoring.dialog.store,
  auth: login.store
};
